import React, { useCallback, useMemo } from "react";
import './style.scss'
import useHidePopup from "../../modules/result-popup/hooks/use-hide-popup";
import { useResultPopupModuleState, POPUP_TYPE } from "../../modules/result-popup";

export default function ResultPopup() {

    const { isDisplayed, type, triesLeft } = useResultPopupModuleState();
    const hidePopup = useHidePopup();

    const onClosePopup = useCallback(() => {
        hidePopup();
    }, [hidePopup])


    const { header, message, showClose } = useMemo(() => {
        switch (type) {
            case POPUP_TYPE.CORRECT:
                return {
                    header: 'Brawo!',
                    message: 'Udało się!',
                    showClose: true
                }

            case POPUP_TYPE.THE_END:
            case POPUP_TYPE.TIME_END:
                return {
                    header: 'Dziękujemy za udział w grze!',
                    message: 'Zapraszamy na dalszą część konferencji :)'
                }

            case POPUP_TYPE.WRONG: {
                switch (triesLeft) {
                    case 2:
                        return {
                            header: 'Ups!',
                            message: 'To nie ta placówka edukacyjna. Masz jeszcze <strong>dwie szanse</strong> na odgadnięcie!',
                            showClose: true
                        }

                    case 1:
                        return {
                            header: 'Ups!',
                            message: 'To też nie ta. Masz <strong>ostatnią szansę</strong> na odgadnięcie. Zastanów się dobrze!',
                            showClose: true
                        }

                    case 0:
                        return {
                            header: 'Ups!',
                            message: 'Niestety to odpowiedź również nie jest poprawna. Spróbuj z inną ścieżką!',
                            showClose: true
                        }

                    default:
                        return {
                            header: 'Ups!',
                            message: 'To nie ta placówka edukacyjna.',
                            showClose: true
                        }
                }
            }

        }
    }, [type, triesLeft])

    return (
        <>
            {isDisplayed && <div className='result-popup column'>
                <div className="popup-container">
                    {showClose && <div className="close" onClick={onClosePopup}></div>}
                    <div className="page-container column">
                        <h2>{header}</h2>
                        <p dangerouslySetInnerHTML={{ __html: message }}></p>
                    </div>
                </div>
            </div>}
        </>
    );
}
